/* eslint-disable vue/valid-v-bind */
<template>
  <div :class="[{ root: true, sidebarClose, sidebarStatic }, 'sing-dashboard']">
    <Sidebar />
    <div class="wrap">
      <Header />
      <v-touch class="content" @swipe="handleSwipe" :swipe-options="{ direction: 'horizontal' }">
        <transition name="router-animation">
          <router-view :key="$route.fullPath" />
        </transition>
        <footer class="contentFooter">
          <!-- Sing App Vue Dashboard Free Template - Made by <a href="https://flatlogic.com" rel="nofollow noopener noreferrer" target="_blank">Flatlogic</a> -->
        </footer>
      </v-touch>
    </div>
  </div>
</template>

<script>
// import { createNamespacedHelpers } from 'vuex'
import { mapState, mapActions } from 'vuex'
import Sidebar from '@/components/sidebar/Sidebar'
import Header from '@/components/header/Header'
import './Layout.scss'

// const { mapState, mapActions } = createNamespacedHelpers('layout')

export default {
  name: 'Layout',
  components: { Sidebar, Header },
  methods: {
    ...mapActions('layout', ['switchSidebar', 'handleSwipe', 'changeSidebarActive', 'toggleSidebar']),
    handleWindowResize() {
      const width = window.innerWidth
      if (width <= 768 && this.sidebarStatic) {
        this.toggleSidebar()
        this.changeSidebarActive(null)
      }
    }
  },

  computed: {
    ...mapState('layout', ['sidebarClose', 'sidebarStatic']),
    ...mapState('authentication', ['userInfo'])
  },

  created() {
    const staticSidebar = JSON.parse(localStorage.getItem('sidebarStatic'))

    if (staticSidebar) {
      this.$store.state.layout.sidebarStatic = true
    } else if (!this.sidebarClose) {
      setTimeout(() => {
        this.switchSidebar(true)
        this.changeSidebarActive(null)
      }, 2500)
    }

    this.handleWindowResize()
    window.addEventListener('resize', this.handleWindowResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize)
  }
}
</script>

<style src="./Layout.scss" lang="scss" scoped />
